import React, { useEffect, useRef, useState } from 'react';
import { Quote, CornerDownRight } from 'lucide-react';
import { escapeHtml } from './forumUtils';
import { normalizeHtml } from '../../lib/htmlText';

// Quoted message bubble (XenForo-style). Collapses long quotes behind
// "mostrar más" and offers a jump link back to the original post.
export function QuoteBlock({ quote }) {
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);
  const ref = useRef(null);
  const html = quote?.body_html || (quote?.excerpt ? `<p>${escapeHtml(quote.excerpt)}</p>` : '');
  useEffect(() => {
    if (ref.current) {
      setOverflowing(ref.current.scrollHeight > ref.current.clientHeight + 4);
    }
  }, [html, expanded]);
  if (!html) return null;

  function jump() {
    if (!quote.post_id) return;
    const el = document.getElementById(`post-${quote.post_id}`);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.add('ring-2', 'ring-cmic-400');
    setTimeout(() => el.classList.remove('ring-2', 'ring-cmic-400'), 1600);
  }

  return (
    <blockquote data-testid="forum-post-quote" className="mb-4 rounded-xl border border-cmic-100 bg-cmic-50/60 overflow-hidden">
      <div className="flex items-center justify-between gap-2 px-4 py-2 border-b border-cmic-100 text-xs font-semibold text-cmic-700 bg-cmic-50">
        <span className="flex items-center gap-1.5 min-w-0">
          <Quote size={12} className="rotate-180 flex-shrink-0" />
          <span className="truncate">{quote.author_name || 'Miembro'} escribió:</span>
        </span>
        {quote.post_id && (
          <button
            onClick={jump}
            data-testid="forum-post-quote-jump"
            className="inline-flex items-center gap-1 text-[11px] font-medium text-cmic-600 hover:text-cmic-800 flex-shrink-0"
          >
            <CornerDownRight size={11} /> Ir al mensaje
          </button>
        )}
      </div>
      <div
        ref={ref}
        className={`forum-rich-content break-words px-4 py-3 text-sm text-slate-600 transition-all ${expanded ? '' : 'max-h-40 overflow-hidden'}`}
        dangerouslySetInnerHTML={{ __html: normalizeHtml(html) }}
      />
      {(overflowing || expanded) && (
        <button
          onClick={() => setExpanded((e) => !e)}
          data-testid="forum-post-quote-toggle"
          className="w-full text-center text-xs font-semibold text-cmic-600 hover:text-cmic-700 py-2 border-t border-cmic-100 hover:bg-cmic-50/80 transition-colors"
        >
          {expanded ? 'Mostrar menos' : 'Mostrar más'}
        </button>
      )}
    </blockquote>
  );
}

export default QuoteBlock;
